import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import {adminsSlice} from "../app/modules/Overview/_redux/admins/adminsSlice";
import {pendingActionsSlice} from "../app/modules/Overview/_redux/pending-action/pendingActionsSlice";
import {settingsSlice} from "../app/modules/Overview/_redux/settings/settingsSlice";
import {usersSlice} from "../app/modules/UserManagement/_redux/users/usersSlice";
import {selectedUserSlice} from "../app/modules/UserManagement/_redux/selected-user/selectedUserSlice";
import {instrumentsSlice} from "../app/modules/Instrument/_redux/instruments/instrumentsSlice";
import {selectedInstrumentSlice} from "../app/modules/Instrument/_redux/selected-instrument/selectedInstrumentSlice";
import {oversightApi} from "./apiSlice";

const appReducer = combineReducers({
    [oversightApi.reducerPath]: oversightApi.reducer,
    auth: auth.reducer,
    admins: adminsSlice.reducer,
    pendingActions: pendingActionsSlice.reducer,
    settings: settingsSlice.reducer,
    users: usersSlice.reducer,
    selectedUser: selectedUserSlice.reducer,
    instruments: instrumentsSlice.reducer,
    selectedInstrument: selectedInstrumentSlice.reducer,
});

export const rootReducer = (state, action) => {
    if (action.type === '[Logout] Action') {
        /* Clear All Data on logout */
        localStorage.removeItem('persist:oversight-dashboard');
        state = undefined
    } else if (action.type === '[Session Update] Action') {
        /* Update Data in Local Storage */
        const persistData = JSON.parse(localStorage.getItem('persist:oversight-dashboard'));
        if (persistData !== null) {
            persistData.authToken = JSON.stringify(action.payload.authToken);
            persistData.session = JSON.stringify(action.payload.session);
            persistData.user = JSON.stringify(state.auth.user);
            localStorage.setItem('persist:oversight-dashboard', JSON.stringify(persistData));
        }
    }

    return appReducer(state, action)
}

export function* rootSaga() {
    yield all([auth.saga()]);
}
